import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Layers, Sparkles } from 'lucide-react';
import { SectionShell } from './SectionShell';
const pillars = [{
  icon: Sparkles,
  title: 'Nada de teoría reciclada',
  body: 'Este bundle no es una colección de teorías sacadas de un libro de psicología de los años 90.'
}, {
  icon: Layers,
  title: 'Cubre todos los ángulos',
  body: 'Desde el primer momento en que ves a alguien, hasta cómo crear una conexión que se siente real, profunda y natural.'
}, {
  icon: BookOpen,
  title: 'Listo para usar hoy',
  body: 'Una guía práctica y directa que puedes aplicar en tu próxima conversación, no en tu próxima década.'
}];
export function SolutionSection() {
  return <SectionShell eyebrow="La solución" title={<>
          Todo lo que necesitas saber sobre amor, atracción y conexión real —{' '}
          <span className="text-gold-400" data-id="element-230" data-mp="fujtd11xruwy">en un solo lugar</span>
        </>} className="bg-noir-950" data-id="element-229" data-mp="5xe1hqlhzzvo">
      <div className="mx-auto grid max-w-5xl gap-3 sm:gap-5 md:grid-cols-3" data-id="element-231" data-mp="36c6v523ghyx2">
        {pillars.map((pillar, index) => <motion.article key={pillar.title} initial={{
        opacity: 0,
        y: 26
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.55,
        delay: index * 0.08,
        ease: [0.22, 1, 0.36, 1]
      }} whileHover={{
        y: -6
      }} className="flex h-full flex-col rounded-2xl border border-gold-500/15 bg-noir-800/60 p-5 text-left transition-colors hover:border-gold-500/40 sm:p-7" data-id="element-232" data-mp="3bbt8rcn75h6e" data-mpi={index}>
            <span className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-gold-500/10 ring-1 ring-gold-500/25 sm:mb-5 sm:h-12 sm:w-12" data-id="element-233" data-mp="2w00tm6xle0y">
              <pillar.icon className="h-5 w-5 text-gold-400" aria-hidden="true" data-id="element-234" data-mp="bvmvlp55nll1" />
            </span>
            <h3 className="font-display text-lg font-semibold text-cream" data-id="element-235" data-mp="gupzh69eflrf">
              {pillar.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-cream/60" data-id="element-236" data-mp="2cxcjqu8b63er">{pillar.body}</p>
          </motion.article>)}
      </div>

      <motion.p initial={{
      opacity: 0,
      scale: 0.96
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }} className="mx-auto mt-8 flex w-full max-w-xl flex-wrap items-center justify-center gap-x-3 gap-y-1.5 rounded-2xl border border-cream/10 bg-noir-800/50 px-6 py-5 font-display text-lg font-semibold text-cream sm:mt-12 sm:gap-x-4 sm:gap-y-2 sm:px-8 sm:py-6 sm:text-2xl" data-id="element-237" data-mp="2mmmdeeisvu4z">
        <span data-id="element-238" data-mp="30mnffxasx7m1">5 ebooks.</span>
        <span className="text-gold-400" data-id="element-239" data-mp="30nfb184ef5cb">Un sistema completo.</span>
        <span className="text-crimson-500" data-id="element-240" data-mp="1b77irhe2ded1">$9.99.</span>
      </motion.p>
    </SectionShell>;
}